import React from 'react';

import qs from 'qs';
import { all, call, put, retry, select } from 'redux-saga/effects';

import { toast } from 'react-toastify';

import { Creators as ContratanteActions } from '../ducks/contratante';
import { Creators as UsuarioActions } from '../ducks/usuario';

import {
  TipoCardRoot,
  TipoPerfilUsuarioEnum,
  TipoStatusEnum,
} from '../../enums';

import { UsuariosAPI } from '../../services/api';
import {
  excludeData,
  getUserData,
  movcadUpt,
  persistData,
} from '../../services/auth';
import { legacyURL } from '../../services/legacy';

import {
  responseHandler,
  responseHandlerGet,
} from '../../utils/responseHandler';

import { ErrorToast } from '../../components/molecules/Toast';

import { toJsonFromBase64 } from '../../utils/array';

export const getAuth = (state) => state.auth;

export function* getConsultaUsuarios(action) {
  try {
    const { TipoStatus } = action.payload;
    const { tipoStatus, totalPages, ...queryParams } = action.payload.params;

    const response = yield all(
      Object.values(TipoStatus).map(function* (status) {
        const queryString = {
          ...queryParams,
          ...(status !== TipoStatusEnum.returnNameForTab.Todas && {
            tipoStatus: status,
          }),
        };

        const objResp = yield retry(5, 2000, UsuariosAPI.get, '', {
          params: queryString,
        });

        objResp.data.status = status;

        return objResp;
      })
    );

    const { isSuccess } = responseHandler(
      response,
      action.payload,
      'data',
      'getConsultaUsuarios',
      200
    );

    const usuarios = response.map((resp) => resp.data);

    const dataUsuarios = {
      response: usuarios,
      isSuccess,
    };

    yield put(
      UsuarioActions.getConsultaUsuariosSuccess(
        dataUsuarios.response,
        dataUsuarios.isSuccess
      )
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getConsultaUsuarios',
      200
    );

    yield put(UsuarioActions.getConsultaUsuariosError(unsuccessResponse));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de usuários.
      </ErrorToast>
    );
  }
}

export function* getConsultaUsuarioPorStatus(action) {
  const paramsPayload = action.payload.params;

  const { tipoStatus, totalPages, ...newParams } = action.payload.params;

  const queryString = {
    ...newParams,
    ...(paramsPayload.tipoStatus !== TipoStatusEnum.returnNameForTab.Todas && {
      tipoStatus: paramsPayload.tipoStatus,
    }),
  };

  try {
    const response = yield retry(5, 2000, UsuariosAPI.get, '', {
      params: queryString,
    });

    response.data.status = tipoStatus;

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getConsultaUsuarios',
      200
    );

    const dataUsuarios = {
      response: response.data,
      isSuccess,
    };

    yield put(
      UsuarioActions.getConsultaUsuariosPorStatusSuccess(
        dataUsuarios.response,
        dataUsuarios.isSuccess
      )
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getConsultaUsuarios',
      200
    );

    yield put(UsuarioActions.getConsultaUsuariosError(unsuccessResponse));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de usuários.
      </ErrorToast>
    );
  }
}

export function* patchLiberarAcesso(action) {
  try {
    const { usuarios } = action.payload;

    const response = yield all(
      usuarios.map((usuario) =>
        retry(
          2,
          2000,
          UsuariosAPI.patch,
          `/${usuario.idUsuario}/liberar-acesso`
        )
      )
    );

    const { unsuccessResponse, isSuccess } = responseHandler(
      response,
      usuarios,
      'idUsuario',
      'patchLiberarAcesso',
      204
    );
    yield put(
      UsuarioActions.patchLiberarAcessoSuccess(unsuccessResponse, isSuccess)
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getUsuarioById',
      200
    );
    yield put(UsuarioActions.patchLiberarAcessoError(unsuccessResponse, error));
  }
}

export function* getUsuarioById(action) {
  const { idUsuario } = action.payload;

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${idUsuario}/dados-gerais`
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getUsuarioById',
      200
    );

    if (isSuccess) {
      const usuarioById = {
        ...response.data,
      };

      yield put(UsuarioActions.getUsuarioByIdSuccess(usuarioById, isSuccess));
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getUsuarioById',
      200
    );

    yield put(UsuarioActions.getUsuarioByIdError(unsuccessResponse, error));
  }
}

export function* patchStatus(action) {
  try {
    const { usuarios, tipoStatus } = action.payload;

    const response = yield all(
      usuarios.map((usuario) =>
        retry(2, 2000, UsuariosAPI.patch, `${usuario.idUsuario}/status`, {
          tipoStatusUsuario: tipoStatus,
        })
      )
    );

    const { unsuccessResponse, isSuccess } = responseHandler(
      response,
      usuarios,
      'idUsuario',
      'patchStatus',
      204
    );

    yield put(UsuarioActions.patchStatusSuccess(unsuccessResponse, isSuccess));
  } catch (error) {
    yield put(UsuarioActions.patchStatusError(error));
  }
}

export function* criarUsuario(action) {
  try {
    const { data } = action.payload;
    const newUsuario = {
      email: data.email,
      matricula: data.matricula,
      codigoContratante: data.codigoContratante,
      nome: data.nome,
      tipoPerfilUsuario: data.tipoPerfilUsuario,
      tipoStatusUsuario: data.tipoStatusUsuario,
    };

    // Cria novo usuário
    const response = yield retry(10, 2000, UsuariosAPI.post, ``, newUsuario);

    const isSuccess =
      response.status > 199 &&
      response.status < 299 &&
      response.data.validationResult.isValid;

    if (isSuccess) {
      const newUsuario = {
        ...response.data,
      };

      // Adiciona contato ao usuário cadastrado
      const hasContato = data.contato.every((c) => !!c.numero && !!c.ddd);

      if (hasContato) {
        const contatos = data.contato.filter((c) => !!c.numero && !!c.ddd);

        yield put(
          UsuarioActions.patchRegistrarContatoRequest(
            { contatos },
            response.data.idUsuario
          )
        );
      }

      // Adiciona a parametrizacao ao usuario cadastrado
      if (data?.cards?.length > 0) {
        const responseCards = yield all(
          data.cards.map((card) =>
            retry(
              5,
              2000,
              UsuariosAPI.post,
              `/${response.data.idUsuario}/parametrizacao`,
              card
            )
          )
        );
        const success = responseCards.every(
          (a) => a.status > 199 && a.status < 299
        );

        yield put(
          UsuarioActions.postParametrizacaoUsuarioSuccess(response, success)
        );
        yield put(UsuarioActions.parametrizacaoNodeRenew());
      }

      // Libera o acesso ao usuario cadastrado
      if (
        data.tipoStatusUsuario !==
        TipoStatusEnum.returnNameForName.PendenteLiberacao
      ) {
        yield retry(
          2,
          2000,
          UsuariosAPI.patch,
          `${response.data.idUsuario}/liberar-acesso`
        );
      }
      yield put(UsuarioActions.usuarioEspelhoRenew());
      yield put(UsuarioActions.criarUsuarioSuccess(newUsuario, isSuccess));
    } else {
      yield put(
        UsuarioActions.criarUsuarioError(
          response.data.validationResult.errors,
          response.data.validationResult.errors[0].errorMessage
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'criarUsuario',
      200
    );

    yield put(UsuarioActions.criarUsuarioError(unsuccessResponse, error));
  }
}

export function* patchRegistrarContato(action) {
  try {
    const { contatos, idUsuario } = action.payload;

    const response = yield retry(
      2,
      2000,
      UsuariosAPI.post,
      `${idUsuario}/contato`,
      contatos
    );

    const { unsuccessResponse, isSuccess } = responseHandlerGet(
      response,
      contatos,
      'patchRegistrarContato',
      200
    );

    yield put(
      UsuarioActions.patchRegistrarContatoSuccess(unsuccessResponse, isSuccess)
    );
  } catch (error) {
    yield put(UsuarioActions.patchRegistrarContatoError(error));
  }
}

export function* getContatoById(action) {
  const { idUsuario } = action.payload;

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${idUsuario}/contato`
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getContatoById',
      200
    );

    if (isSuccess) {
      const contatoById = response.data;

      yield put(UsuarioActions.getContatoByIdSuccess(contatoById, isSuccess));
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getContatoById',
      200
    );

    yield put(UsuarioActions.getContatoByIdError(unsuccessResponse, error));
  }
}

export function* patchSenha(action) {
  const auth = yield select(getAuth);
  persistData(auth.token);
  try {
    const { idUsuario, senha, novaSenha, confirmacaoSenha } = action.payload;

    const newPassword = {
      senha,
      novaSenha,
      confirmacaoSenha,
    };

    const response = yield retry(
      2,
      2000,
      UsuariosAPI.patch,
      `${idUsuario}/password`,
      newPassword
    );

    const { isSuccess } = responseHandlerGet(
      response,
      newPassword,
      'patchSenha',
      204
    );

    yield put(UsuarioActions.patchSenhaSuccess(isSuccess));
  } catch (error) {
    excludeData();
    yield put(
      UsuarioActions.patchSenhaError(error.response?.data?.errors?.Messages)
    );
  }
}

export function* getDadosAcessoById(action) {
  const { idUsuario } = action.payload;

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${idUsuario}/dados-acesso`
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getDadosAcessoById',
      200
    );

    if (isSuccess) {
      const usuarioById = {
        ...response.data,
      };

      yield put(
        UsuarioActions.getDadosAcessoByIdSuccess(usuarioById, isSuccess)
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getDadosAcessoById',
      200
    );

    yield put(UsuarioActions.getDadosAcessoByIdError(unsuccessResponse, error));
  }
}

export function* patchDadosGerais(action) {
  const { params, contatos } = action.payload;
  const requestBody = {
    nome: params.nome,
    matricula: params.matricula,
    tipoPerfilUsuario: params.tipoPerfil,
    ...(contatos.contatos && contatos.contatos.length > 0
      ? { contatos: contatos.contatos }
      : { contatos: [] }),
  };

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.patch,
      `${params.idUsuario}/dados-gerais`,
      requestBody
    );

    const { isSuccess } = responseHandlerGet(
      response,
      requestBody,
      'patchDadosGerais',
      204
    );

    yield put(UsuarioActions.patchDadosGeraisSuccess(response.data, isSuccess));
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.response,
      'patchDadosGerais',
      204
    );
    yield put(UsuarioActions.patchDadosGeraisError(unsuccessResponse, error));
  }
}

export function* patchDadosAcesso(action) {
  const { params } = action.payload;

  const requestBody = {
    email: params.email,
  };

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.patch,
      `${params.idUsuario}/dados-acesso`,
      requestBody
    );
    const { isSuccess } = responseHandlerGet(
      response,
      requestBody,
      'patchDadosAcesso',
      204
    );

    yield put(UsuarioActions.patchDadosAcessoSuccess(response.data, isSuccess));
  } catch (error) {
    yield put(
      UsuarioActions.patchDadosAcessoError(
        [],
        error.response.data.errors.Messages
      )
    );
  }
}

export function* getHistoricoMovimentacoes(action) {
  const { idUsuario, params } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${idUsuario}/historico-alteracoes`,
      {
        params: queryString,
      }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getHistoricoMovimentacoes',
      200
    );

    if (isSuccess) {
      const historicoMovimentacao = {
        ...response.data,
      };

      yield put(
        UsuarioActions.getHistoricoMovimentacoesSuccess(
          historicoMovimentacao,
          isSuccess
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getHistoricoMovimentacoes',
      200
    );

    yield put(
      UsuarioActions.getHistoricoMovimentacoesError(unsuccessResponse, error)
    );
  }
}

export function* postParametrizacaoContratante(action) {
  try {
    const { contratantes } = action.payload;

    const response = yield retry(5, 2000, UsuariosAPI.post, ``, contratantes);

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'postParametrizacaoContratante',
      200
    );

    yield put(
      UsuarioActions.postParametrizacaoContratanteSuccess(response, true)
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'postParametrizacaoContratante',
      200
    );

    yield put(
      UsuarioActions.postParametrizacaoContratanteError(
        unsuccessResponse,
        error
      )
    );
  }
}

export function* getParametrizacaoUsuario(action) {
  const { params } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(2, 2000, UsuariosAPI.get, `/parametrizacao`, {
      params: queryString,
    });

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getParametrizacaoUsuario',
      200
    );

    if (isSuccess) {
      const parametrizacao = {
        ...response.data,
      };

      yield put(
        UsuarioActions.getParametrizacaoUsuarioSuccess(
          parametrizacao,
          isSuccess
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getParametrizacaoUsuario',
      200
    );

    yield put(
      UsuarioActions.getParametrizacaoUsuarioError(unsuccessResponse, error)
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de contratantes
        parametrizadas.
      </ErrorToast>
    );
  }
}

export function* getContratantesUsuario(action) {
  const idUsuario = action.payload.params;

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `/${idUsuario}/contratante-parametrizada`
    );

    const isSuccess = response.status > 199 || response.status < 299;

    if (isSuccess) {
      const contratantes = {
        ...response.data,
      };

      yield put(
        UsuarioActions.getContratantesUsuarioSuccess(contratantes, isSuccess)
      );
    }
  } catch (error) {
    yield put(UsuarioActions.getContratantesUsuarioError([], error));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de contratantes desse
        usuário.
      </ErrorToast>
    );
  }
}

export function* postParametrizacaoUsuario(action) {
  try {
    const { idUsuario, cards } = action.payload;

    const response = [];
    const newCards = [];
    yield* cards.map(function* (card, index) {
      const { idCard, ...rest } = card;

      const resp = yield retry(
        2,
        2000,
        UsuariosAPI.post,
        `/${idUsuario}/parametrizacao`,
        rest
      );
      if (resp.data.idParametrizacao > 0)
        newCards.push({
          idCard,
          oldIdParametrizacao: cards[index].idParametrizacao,
          newIdParametrizacao: resp.data.idParametrizacao,
        });
      response.push(resp);
    });

    const isSuccess = response.every((a) => a.status > 199 && a.status < 299);
    const isInvalid = response.every((a) => !a.data.validationResult.isValid);
    const hasValidationErrors = response.some(
      (a) => !a.data.validationResult.isValid
    );

    const newResponse = [];
    response.forEach((r, index) => {
      const resp = {
        data: r.data,
        idCard: cards[index].idCard,
      };

      newResponse.push(resp);
    });

    if (isSuccess && !isInvalid && !hasValidationErrors) {
      yield put(
        UsuarioActions.postParametrizacaoUsuarioSuccess(
          newResponse,
          isSuccess,
          false,
          ''
        )
      );
      yield put(ContratanteActions.parametrizacaoSetId(newCards));
    } else if (isSuccess && hasValidationErrors && !isInvalid) {
      const errors = [];

      response.map((a) =>
        a.data.validationResult.errors.length > 0
          ? errors.push(a.data.validationResult.errors[0]?.errorMessage)
          : null
      );

      yield put(
        UsuarioActions.postParametrizacaoUsuarioSuccess(
          newResponse,
          isSuccess,
          hasValidationErrors,
          errors
        )
      );
    } else {
      const responseErrors = {
        errors: response.map((a) => a.data.validationResult.errors),
        message: response.map(
          (a) => a.data.validationResult.errors[0]?.errorMessage
        ),
      };

      yield put(
        UsuarioActions.postParametrizacaoUsuarioError(
          responseErrors.errors,
          responseErrors.message
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'postParametrizacaoUsuario',
      200
    );

    yield put(
      UsuarioActions.postParametrizacaoUsuarioError(unsuccessResponse, error)
    );
  }
}

export function* getParametrizacaoCards(action) {
  const { params, cards } = action.payload;

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${params.idUsuario}/parametrizacao-cards`
    );
    const isSuccess = response.status > 199 && response.status < 299;

    if (isSuccess) {
      const parametrizacaoCards = {
        ...response.data,
      };

      yield put(
        ContratanteActions.parametrizacaoSetContagem([
          ...parametrizacaoCards.grupoComplementoCard,
          ...parametrizacaoCards.contratanteCard,
        ])
      );

      yield put(UsuarioActions.getParametrizacaoCardsSuccess(cards, true));
      yield put(ContratanteActions.parametrizacaoSetLoadingCards(false, cards));
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getParametrizacaoCards',
      200
    );

    yield put(
      UsuarioActions.getParametrizacaoCardsError(
        unsuccessResponse,
        error,
        cards
      )
    );
    yield put(ContratanteActions.parametrizacaoSetLoadingCards(false, cards));
    toast.error(
      <ErrorToast size="30">
        Não foi possível obter as parametrizações do usuário.
      </ErrorToast>
    );
  }
}

export function* getParametrizacaoNode(action) {
  const { idUsuario, params, node } = action.payload;

  const { path, idCard, ...rest } = params;

  const queryString = {
    ...rest,
  };

  try {
    const response = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `/${idUsuario}/parametrizacao-${node}-node`,
      {
        params: queryString,
      }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getParametrizacaoNode',
      200
    );

    if (isSuccess) {
      const nodes = {
        ...response.data,
        idCard: params.idCard,
        path: params.path,
        currentPath: params.currentPath,
        ...(params.codigoContratante && {
          codigoContratante: params.codigoContratante,
        }),
      };

      yield put(UsuarioActions.getParametrizacaoNodeSuccess(nodes, isSuccess));

      if (node === 'contratante')
        yield put(
          ContratanteActions.getGrupoContratantesSuccess(nodes, isSuccess)
        );
      if (node === 'modalidade')
        yield put(
          ContratanteActions.getContratanteModalidadesSuccess(nodes, isSuccess)
        );
      if (node === 'termo')
        yield put(
          ContratanteActions.getModalidadeTermosSuccess(nodes, isSuccess)
        );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getParametrizacaoNode',
      200
    );

    yield put(
      UsuarioActions.getParametrizacaoNodeError(unsuccessResponse, error)
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para a consulta de {node}s desse
        usuário.
      </ErrorToast>
    );
  }
}

export function* postAtualizarSessaoLegado(action) {
  try {
    const { token } = action.payload;

    const userData = JSON.stringify(getUserData());
    const requestObject = `{ token:${JSON.stringify(userData)}}`;

    const headersRequest = {
      'Content-Type': 'application/json',
    };

    const response = yield retry(
      10,
      2000,
      legacyURL.post,
      `/Login.aspx/AtualizarSessao`,
      requestObject,
      { headers: headersRequest }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      token,
      'postAtualizarSessaoLegado',
      204
    );

    yield put(
      UsuarioActions.postAtualizarSessaoLegadoSuccess(response.data, isSuccess)
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.response,
      'postAtualizarSessaoLegado',
      204
    );
    yield put(
      UsuarioActions.postAtualizarSessaoLegadoError(unsuccessResponse, error)
    );
  }
}

export function* putParametrizacaoUsuario(action) {
  try {
    const { idUsuario, cards } = action.payload;

    const response = [];
    yield* cards.map(function* (card, index) {
      const resp = yield retry(
        5,
        2000,
        UsuariosAPI.put,
        `/${idUsuario}/parametrizacao`,
        card
      );

      response.push(resp);
    });

    const isSuccess = response.every((a) => a.status > 199 && a.status < 299);
    const isInvalid = response.every((a) => !a.data.validationResult.isValid);
    const hasValidationErrors = response.some(
      (a) => !a.data.validationResult.isValid
    );

    const newCards = response.map((c, index) => {
      return {
        oldIdParametrizacao: cards[index].idParametrizacao,
        newIdParametrizacao: c.data.idParametrizacao,
      };
    });

    if (isSuccess && !isInvalid && !hasValidationErrors) {
      yield put(
        UsuarioActions.putParametrizacaoUsuarioSuccess(
          newCards,
          isSuccess,
          false,
          ''
        )
      );
      yield put(ContratanteActions.parametrizacaoUpdateId(newCards));
    } else if (isSuccess && hasValidationErrors && !isInvalid) {
      const errors = [];

      response.map((a) =>
        a.data.validationResult.errors.length > 0
          ? errors.push(a.data.validationResult.errors[0]?.errorMessage)
          : null
      );

      yield put(
        UsuarioActions.putParametrizacaoUsuarioSuccess(
          newCards,
          isSuccess,
          hasValidationErrors,
          errors
        )
      );
      yield put(ContratanteActions.parametrizacaoUpdateId(newCards));
    } else {
      const responseErrors = {
        errors: response.map((a) => a.data.validationResult.errors),
        message: response.map(
          (a) => a.data.validationResult.errors[0]?.errorMessage
        ),
      };

      yield put(
        UsuarioActions.putParametrizacaoUsuarioError(
          responseErrors.errors,
          responseErrors.message || 'Erro ao alterar a parametrização.'
        )
      );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'putParametrizacaoUsuario',
      200
    );

    yield put(
      UsuarioActions.putParametrizacaoUsuarioError(
        unsuccessResponse,
        'Erro ao alterar a parametrização.'
      )
    );
  }
}
export function* getParametrizacaoCardsCompleto(action) {
  try {
    const { idUsuario, idCard, ...rest } = action.payload;

    const paramsRequest = qs.stringify(rest, {
      addQueryPrefix: true,
      skipNulls: true,
    });

    const response = yield retry(
      5,
      2000,
      UsuariosAPI.get,
      `/${idUsuario}/parametrizacao-card-completo`,
      {
        params: rest,
      }
    );

    const isSuccess = response.status > 199 && response.status < 299;

    // yield put(
    //   UsuarioActions.getParametrizacaoCardsCompletoSuccess(
    //     response.data,
    //     isSuccess
    //   )
    // );

    const treeContent = JSON.parse(
      toJsonFromBase64(response.data.parametrizacao)
    );

    yield put(
      ContratanteActions.parametrizacaoSetCardCompleto(treeContent, idCard)
    );
  } catch (error) {
    console.log(error);
    yield put(UsuarioActions.getParametrizacaoCardsCompletoError(error));
  }
}
export function* patchParametrizacaoInativar(action) {
  try {
    const { idUsuario, idCard, ...rest } = action.payload;

    const response = yield retry(
      5,
      2000,
      UsuariosAPI.patch,
      `/${idUsuario}/parametrizacao-inativar`,
      {},
      {
        params: rest,
      }
    );

    const isSuccess = response.status > 199 && response.status < 299;

    if (isSuccess) {
      yield put(
        UsuarioActions.patchParametrizacaoInativarSuccess(
          response.data,
          isSuccess
        )
      );
      yield put(ContratanteActions.parametrizacaoDeleteCard(idCard));
    } else
      yield put(
        UsuarioActions.patchParametrizacaoInativarError(
          'Erro ao inativar parametrização.'
        )
      );
  } catch (error) {
    console.log(error);
    yield put(UsuarioActions.patchParametrizacaoInativarError(error));
  }
}

export function* patchParametrizacaoAdmInativar(action) {
  try {
    const { idUsuario } = action.payload;

    const response = yield call(
      UsuariosAPI.patch,
      `/${idUsuario}/parametrizacao-adm-inativar`
    );

    const isSuccess = response.status > 199 && response.status < 299;

    if (isSuccess) {
      yield put(
        UsuarioActions.patchParametrizacaoInativarSuccess(
          response.data,
          isSuccess
        )
      );
      yield put(ContratanteActions.parametrizacaoRootRenew());
      refreshPage();
    } else
      yield put(
        UsuarioActions.patchParametrizacaoInativarError(
          'Erro ao inativar parametrização.'
        )
      );
  } catch (error) {
    yield put(UsuarioActions.patchParametrizacaoInativarError(error));
  }
}

export function* saveParametrizacaoCards(action) {
  const { idUsuario, postCards, putCards } = action.payload;

  const response = [];
  const putCardsIds = [];
  const postCardsIds = [];

  try {
    // #region Request para alterar os cards já parametrizados.
    yield* putCards.map(function* (card, index) {
      const { idCard, name, ...rest } = card;
      const resp = yield retry(
        5,
        2000,
        UsuariosAPI.put,
        `/${idUsuario}/parametrizacao`,
        rest
      );

      putCardsIds.push({
        oldIdParametrizacao: card.idParametrizacao,
        newIdParametrizacao: resp.data.idParametrizacao,
      });

      response.push({ ...resp, name });
    });
    // #endregion

    // #region Request para adicionar novos cards parametrizados.
    yield* postCards.map(function* (card, index) {
      const { idCard, name, ...rest } = card;

      const resp = yield retry(
        2,
        2000,
        UsuariosAPI.post,
        `/${idUsuario}/parametrizacao`,
        rest
      );

      postCardsIds.push({
        idCard,
        oldIdParametrizacao: card.idParametrizacao,
        newIdParametrizacao: resp.data.idParametrizacao,
      });

      response.push({ ...resp, name });
    });
    // #endregion

    // #region Verifica se há erros de validação ao inserir as parametrizações
    const { isSuccess, isInvalid, hasValidationErrors, errors } =
      isValid(response);
    // #endregion

    // #region Atualiza os Id'sParametrização a partir do response
    if (postCards.length > 0)
      yield put(ContratanteActions.parametrizacaoSetId(postCardsIds));
    if (putCards.length > 0)
      yield put(ContratanteActions.parametrizacaoUpdateId(putCardsIds));
    // #endregion

    if (isSuccess && !isInvalid && !hasValidationErrors) {
      yield put(
        UsuarioActions.saveParametrizacaoCardsSuccess(
          [...postCards, ...putCards],
          true,
          false,
          ''
        )
      );
      yield put(
        ContratanteActions.parametrizacaoToogleCard(
          [...postCardsIds, ...putCardsIds],
          true
        )
      );
    } else if (isSuccess && !isInvalid && hasValidationErrors) {
      yield put(
        UsuarioActions.saveParametrizacaoCardsSuccess(
          [...postCards, ...putCards],
          true,
          hasValidationErrors,
          errors
        )
      );
      yield put(
        ContratanteActions.parametrizacaoToogleCard(
          [...postCardsIds, ...putCardsIds],
          true
        )
      );
    } else yield put(UsuarioActions.saveParametrizacaoCardsError(errors, true));
  } catch (error) {
    console.log(error);
    yield put(
      UsuarioActions.saveParametrizacaoCardsError(error, error?.message)
    );
  }
}

export function* getAndBuildParametrizacaoCards(action) {
  const { params } = action.payload;
  const cardsResponse = {
    ContratanteRoot: [],
    GrupoRoot: [],
  };
  try {
    const cards = yield retry(
      2,
      2000,
      UsuariosAPI.get,
      `${params.idUsuario}/parametrizacao-cards`
    );

    cardsResponse.ContratanteRoot = cards.data.contratanteCard.map((c) => ({
      Card: c,
      Tree: [],
    }));
    cardsResponse.GrupoRoot = cards.data.grupoComplementoCard.map((c) => ({
      Card: c,
      Tree: [],
    }));

    const newCards = [
      ...cardsResponse.ContratanteRoot.map((c) => c.Card),
      ...cardsResponse.GrupoRoot.map((g) => g.Card),
    ];

    if (params?.isParametrizacaoEspelho) {
      // Limpando parametrização atual
      yield put(ContratanteActions.parametrizacaoRootRenew());

      yield put(
        ContratanteActions.parametrizacaoSetCardsById(
          newCards.map((card) => ({ ...card, idParametrizacao: 0 }))
        )
      );

      if (cardsResponse.ContratanteRoot.length > 0) {
        yield* cardsResponse.ContratanteRoot.map(function* (card) {
          const cardCompleto = yield call(
            UsuariosAPI.get,
            `/${params.idUsuario}/parametrizacao-card-completo`,
            {
              params: { idParametrizacao: card.Card.idParametrizacao },
            }
          );
          card.Tree = JSON.parse(
            toJsonFromBase64(cardCompleto.data.parametrizacao)
          );
        });
      }

      if (cardsResponse.GrupoRoot.length > 0) {
        yield* cardsResponse.GrupoRoot.map(function* (card) {
          const cardCompleto = yield call(
            UsuariosAPI.get,
            `/${params.idUsuario}/parametrizacao-card-completo`,
            {
              params: { idParametrizacao: card.Card.idParametrizacao },
            }
          );
          card.Tree = JSON.parse(
            toJsonFromBase64(cardCompleto.data.parametrizacao)
          );
        });
      }

      /*
      const contratanteRoot = [];
      const grupoRoot = [];

      newCards.forEach((card) => {
        if (card.tipoParametrizacao === TipoCardRoot.returnNameAPI[0]) {
          contratanteRoot.push({
            contratante: { ...card, idParametrizacao: 0 },
          });
        }
        if (card.tipoParametrizacao === TipoCardRoot.returnNameAPI[1]) {
          grupoRoot.push({ complemento: { ...card, idParametrizacao: 0 } });
        }
      });
      if (contratanteRoot.length > 0) {
        yield put(
          ContratanteActions.getParametrizacaoContratanteCompletoRequest(
            contratanteRoot
          )
        );
      }

      if (grupoRoot.length > 0) {
        yield put(
          ContratanteActions.getParametrizacaoGrupoComplementoCompletoRequest(
            grupoRoot
          )
        );
      }
      */
    } else {
      yield put(ContratanteActions.parametrizacaoSetCardsById(newCards));

      if (cardsResponse.ContratanteRoot.length > 0) {
        yield* cardsResponse.ContratanteRoot.map(function* (card) {
          const cardCompleto = yield retry(
            5,
            2000,
            UsuariosAPI.get,
            `/${params.idUsuario}/parametrizacao-card-completo`,
            {
              params: { idParametrizacao: card.Card.idParametrizacao },
            }
          );
          card.Tree = JSON.parse(
            toJsonFromBase64(cardCompleto.data.parametrizacao)
          );
        });
      }

      if (cardsResponse.GrupoRoot.length > 0) {
        yield* cardsResponse.GrupoRoot.map(function* (card) {
          const cardCompleto = yield retry(
            5,
            2000,
            UsuariosAPI.get,
            `/${params.idUsuario}/parametrizacao-card-completo`,
            {
              params: { idParametrizacao: card.Card.idParametrizacao },
            }
          );
          card.Tree = JSON.parse(
            toJsonFromBase64(cardCompleto.data.parametrizacao)
          );
        });
      }
    }
    yield put(
      ContratanteActions.parametrizacaoSetCardsCompleto(
        [...cardsResponse.ContratanteRoot, ...cardsResponse.GrupoRoot],
        params?.isParametrizacaoEspelho
      )
    );

    yield put(UsuarioActions.getAndBuildParametrizacaoCardsSuccess([], true));
  } catch (error) {
    yield put(
      UsuarioActions.getAndBuildParametrizacaoCardsError(error, error.message)
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta das parametrizações.
      </ErrorToast>
    );
  }
}

export function* getUsuarioEspelho(action) {
  const { params } = action.payload;

  try {
    const response = yield call(UsuariosAPI.get, '', {
      params,
    });

    const isSuccess = response.status === 200 || false;

    if (isSuccess) yield put(UsuarioActions.success(response.data));
  } catch (error) {
    yield put(UsuarioActions.error(error));
    toast.error(
      <ErrorToast size="30">Não foi possível listar os usuarios</ErrorToast>
    );
  }
}

export function* patchAtualizarTipoPerfil(action) {
  try {
    const { idUsuario, newRoles } = action.payload;

    const response = yield call(
      UsuariosAPI.patch,
      `/${idUsuario}/atualizar-tipo-perfil`,
      {
        tiposPerfil: [...newRoles],
      }
    );

    const isSuccess = response.status > 199 && response.status < 299;

    if (isSuccess) {
      yield put(UsuarioActions.success({}));
      refreshPage();
    } else yield put(UsuarioActions.error({}));
  } catch (error) {
    yield put(UsuarioActions.error(error));
    toast.error(
      <ErrorToast size="30">Erro ao alterar o perfil do usuario.</ErrorToast>
    );
  }
}

export function* postClonarUsuarioEspelho(action) {
  try {
    const { idUsuario, idUsuarioEspelho } = action.payload;

    const response = yield call(
      UsuariosAPI.post,
      `/${idUsuario}/clonar-usuario-espelho`,
      {
        idUsuarioEspelho,
      }
    );

    const isSuccess = response.status > 199 && response.status < 299;

    if (isSuccess) {
      yield put(UsuarioActions.success({}));
      // Atualizar grid de cards de parametrização
      yield put(ContratanteActions.parametrizacaoRootRenew());
      yield put(
        UsuarioActions.getAndBuildParametrizacaoCardsRequest({ idUsuario })
      );
      refreshPage();
    } else yield put(UsuarioActions.error({}));
  } catch (error) {
    yield put(UsuarioActions.error(error));
    toast.error(
      <ErrorToast size="30">
        Erro ao clonar a parametrização do usuario espelho.
      </ErrorToast>
    );
  }
}
const isValid = (response) => {
  const isSuccess = response.every((a) => a.status > 199 && a.status < 299);
  const isInvalid = response.every((a) => !a.data.validationResult.isValid);
  const hasValidationErrors = response.some(
    (a) => !a.data.validationResult.isValid
  );
  if (hasValidationErrors) {
    const errors = [];

    response.map((a) => {
      if (a.data.validationResult.errors.length > 0) {
        errors.push({
          name: a.name,
          errorMessage: a.data.validationResult.errors[0]?.errorMessage,
        });
      }
    });

    return { isSuccess, isInvalid, hasValidationErrors, errors };
  }

  return { isSuccess, isInvalid, hasValidationErrors };
};

const refreshPage = () => {
  movcadUpt();
  window.location.reload();
};
